module.exports = __webpack_public_path__ + "static/media/Avalugg_gaussian2.a9f9771e.png";